<template>
  <a
    v-smooth-scroll="{
      duration: 1000,
      offset: -110,
      container: '#scroll_content',
    }"
    class="nav-link bold"
    :href="anchorId"
  >
    {{ label }}
    <!-- @slot Emplacement pour une icône. -->
    <slot name="icon" />
    <Counter
      v-if="notification > -1"
      :value="notification"
      size="small"
    />
  </a>
</template>

<script>
import { defineComponent } from "vue";
import Counter from "../../components/infos/Counter.vue";

/**
 * Titre présent dans la page sur lequel on peut cliquer pour s'y rendre.
 * Pour plus d'informations, voir le composant AnchorsGroup.
 */
export default defineComponent({
  name: "Anchor",
  components: {
    Counter,
  },
  props: {
    /**
     * Identifiant HTML de l'ancre dans la page.
     */
    anchorId: {
      type: String,
      default: "#",
    },
    /**
     * Nom à afficher pour l'ancre.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * Affiche un compteur à côté du texte. Il doit être >= 0 pour être affiché.
     */
    notification: {
      type: Number,
      default: -1,
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/nav/anchors_tabs.scss";
</style>
